import { render, staticRenderFns } from "./component.vue?vue&type=template&id=da540cee&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da540cee')) {
      api.createRecord('da540cee', component.options)
    } else {
      api.reload('da540cee', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=da540cee&", function () {
      api.rerender('da540cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/plugins/site-drawer/component.vue"
export default component.exports